module.exports = __webpack_public_path__ + "static/benefit-5-fdb9f864c68e6072f4200951dd184458.svg";